import React from "react";

const Shrink = (props) => {
  return <div className="shrink">{props.children}</div>;
};

export default Shrink;
